import { toastr } from 'react-redux-toastr';
import humps from 'humps';
import * as fetchUtils from 'app/utils/FetchUtils';
import * as RouterUtils from 'app/utils/RouterUtils';
import { CLIENT_INIT_TRANSACTION_NCD_SUCCESS } from 'app/actors/client/constants/Routes';
import { getActiveUser } from 'app/actions/AuthedActions';
import { NCD_INITIATE_SUCCESS } from 'app/products/Constants/Routes';
import { EventTypes } from 'app/utils/reduxAmplitude';
import { CUSTOMER_INITIATE_TRANSACTION } from 'app/constants/AmplitudeActions';
import { PRODUCT_KEYS } from 'app/constants/Constants';

const { isProduct, isClient } = getActiveUser();

const createActionName = (name) => `app/client/ncd/${name}`;

export const CREATE_NCD_TRANSACTION_SUCCESS = createActionName('CREATE_NCD_TRANSACTION_SUCCESS');

const initialState = {
    initializedNcd: null,
};

export default function ncd(state = initialState, action) {
    switch (action.type) {
        case CREATE_NCD_TRANSACTION_SUCCESS:
            return {
                ...state,
                initializedNcd: action.data,
            };
        default:
            return state;
    }
}

function processNcdData(data) {
    let prcessData = {};
    const ratingAgencyIds = [];
    const lawFirmIds = [];
    const registrarIds = [];
    const trusteeIds = [];
    // const yrs = data.tenor.years ? parseInt(data.tenor.years, 10) : 0;
    // const mns = data.tenor.months ? parseInt(data.tenor.months, 10) : 0;
    // const dys = data.tenor.days ? parseInt(data.tenor.days, 10) : 0;

    if (data.ratingAgencyIds) ratingAgencyIds.push(data.ratingAgencyIds.value);
    if (data.lawFirmIds) lawFirmIds.push(data.lawFirmIds);
    if (data.trusteeIds) trusteeIds.push(data.trusteeIds);
    if (data.registrarIds) registrarIds.push(data.registrarIds);

    prcessData = {
        ...data,
        issuanceSize: data.issuanceSize * 10000000,
        rating: (data.rating && data.rating.value) || '',
        ratingAgencyIds,
        lawFirmIds,
        registrarIds,
        trusteeIds,
        tenor: {
            years: data.tenor.years ? parseInt(data.tenor.years, 10) : 0,
            months: data.tenor.months ? parseInt(data.tenor.months, 10) : 0,
            days: data.tenor.days ? parseInt(data.tenor.days, 10) : 0,
        },
    };

    return humps.decamelizeKeys(prcessData);
}

function mapNcd(data) {
    const d = humps.camelizeKeys(data);
    return {
        ...d,
        needLegalAssistance: d.lawFirmIds && d.lawFirmIds.length > 0,
        rating: d.rating
            ? {
                  valid: true,
                  value: d.rating,
              }
            : { valid: false },
    };
}

export function createNcd(data) {
    return (dispatch) =>
        fetchUtils
            .postJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds`, {
                ncd_transaction: processNcdData(data),
            })
            .then((d) => {
                const processedD = mapNcd(d);
                dispatch({ type: CREATE_NCD_TRANSACTION_SUCCESS, data: processedD });
                return processedD;
            })
            .then((d) =>
                dispatch(
                    RouterUtils.pushRoute({
                        path: isProduct ? NCD_INITIATE_SUCCESS : CLIENT_INIT_TRANSACTION_NCD_SUCCESS,
                        keys: { transId: d.id },
                    }),
                ),
            )
            .then(() => {
                if (isClient) {
                    dispatch({
                        type: CUSTOMER_INITIATE_TRANSACTION,
                        meta: {
                            amplitude: [
                                {
                                    eventType: EventTypes.track,
                                    eventPayload: {
                                        eventName: CUSTOMER_INITIATE_TRANSACTION,
                                        transaction_type: PRODUCT_KEYS.ncd,
                                        ...data,
                                    },
                                },
                            ],
                        },
                    });
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Creating NCD', m);
                }),
            );
}
